"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCountryById = exports.defaultCountry = exports["default"] = exports.DEFAULT_COUNTRY = void 0;
var _country = require("./country");
var DEFAULT_COUNTRY = exports.DEFAULT_COUNTRY = 'FR';
var getCountries = function getCountries() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (str) {
    return str;
  };
  return [(0, _country.atCountry)(t), (0, _country.beCountry)(t), (0, _country.bgCountry)(t), (0, _country.chCountry)(t), (0, _country.cyCountry)(t), (0, _country.czCountry)(t), (0, _country.deCountry)(t), (0, _country.dkCountry)(t), (0, _country.eeCountry)(t), (0, _country.esCountry)(t), (0, _country.fiCountry)(t), (0, _country.frCountry)(t), (0, _country.gbCountry)(t), (0, _country.grCountry)(t), (0, _country.hrCountry)(t), (0, _country.huCountry)(t), (0, _country.ieCountry)(t), (0, _country.itCountry)(t), (0, _country.liCountry)(t), (0, _country.ltCountry)(t), (0, _country.luCountry)(t), (0, _country.lvCountry)(t), (0, _country.mtCountry)(t), (0, _country.nlCountry)(t), (0, _country.noCountry)(t), (0, _country.plCountry)(t), (0, _country.ptCountry)(t), (0, _country.roCountry)(t), (0, _country.seCountry)(t), (0, _country.siCountry)(t), (0, _country.skCountry)(t)];
};
var _default = exports["default"] = getCountries;
var defaultCountry = exports.defaultCountry = (0, _country.frCountry)(function (str) {
  return str;
});
var getCountryById = exports.getCountryById = function getCountryById(id) {
  var countries = getCountries(function (str) {
    return str;
  });
  return countries.find(function (country) {
    return country.id === id;
  });
};